export default {
  // 票据分页查询
  QUERY_FUNDBILL_PAGE: '/financial/fundBill/queryPage',
  // 查询应收票据号是否被维护使用
  CHECK_BILLCODEUSED: '/financial/fundBill/checkBillCodeUsed',
  // 票据新增/修改
  SAVE_FUNDBILL: '/financial/fundBill/save',
  // 票据详情
  QUERY_FUNDBILL_BY_ID: '/financial/fundBill/queryById',
  // 付款申请单-生成应付票据-带出付款申请单信息
  QUERY_FUNDBILL_BY_PAYMENTAPPLYID: '/financial/fundBill/getFundBillByPaymentApply',
  // 票据删除
  DEL_FUNDBILL: '/financial/fundBill/delete',
  // 票据撤销
  CANCEL_FUNDBILL: '/financial/fundBill/cancel',
  // 应付票据撤销
  CANCELYF_FUNDBILL: '/financial/fundBill/cancelYF',
  // 票据导出
  EXPORT_FUNDBILL: '/financial/fundBill/exportExcel',
  // 票据批量导入
  IMPORT_FUNDBILL: '/financial/fundBill/importExcel',
  // 票据解付
  PAYMENT_FUNDBILL: '/financial/fundBill/payment',
  // 票据解付并保存
  SAVE_PAYMENT_FUNDBILL: '/financial/fundBill/savePayment',
  // 批量保证金过帐
  BATCH_VOUCHER: '/financial/fundBill/batchSyncVoucher',
  // 批量保证金标记过帐
  BATCH_SIGN_VOUCHER: '/financial/fundBill/batchSignSyncVoucher',
  // 批量解付过帐
  BATCH_OFF_PAY: '/financial/fundBillPayment/batchSyncVoucher',
  // 批量解付标记过帐
  BATCH_SIGN_OFF_PAY: '/financial/fundBillPayment/batchSignSyncVoucher',
  // 应收票据批量过账
  BATCH_VOUCHER_YS: '/financial/fundBill/batchSyncVoucherYS',
  // 应收票据批量标记过账
  BATCH_SIGN_VOUCHER_YS: '/financial/fundBill/batchSignSyncVoucherYS',
};
